import { render, staticRenderFns } from "./FindThePairsPreview.vue?vue&type=template&id=aa73a9d2&"
import script from "./FindThePairsPreview.vue?vue&type=script&lang=js&"
export * from "./FindThePairsPreview.vue?vue&type=script&lang=js&"
import style0 from "./FindThePairsPreview.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FindThePairsPreview.vue"
export default component.exports